<template>
  <div v-if="isLoaded" v-show="isActive" :id="`pane-${tabName}`" ref="content" class="pdl-tab-pane" role="tabpanel">
    <slot></slot>
  </div>
</template>
<script>
import {PdlSlotUtil} from '@pedal/pdl-shared-libraries';
export default {
  name: 'PdlTabPane',

  componentName: 'PdlTabPane',

  inject: ['createTab', 'activeTabName', 'paneIndex', 'removeTab', 'restoreTab'],

  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      index: null,
      isLoaded: false,
      isActive: false,
      isRemoved: false,
      tabName: '',
      observer: null,
    };
  },
  created() {
    // check if tab has any content by checking $slots
    if(!PdlSlotUtil.hasSlotContent(this.$slots.default)) return;
    this.tabName = this.name || `tab-${this.paneIndex + 1}`;
    this.createTabWithPayload();

  },
  unmounted(){
    this.removeTab(this.tabName);
    this.observer?.disconnect();
  },
  watch: {
    activeTabName: {
      handler() {
        const isActive = this.activeTabName === this.tabName;
        this.isActive = isActive;

        if (!this.isLoaded && isActive) {
          this.isLoaded = true;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isLoaded = this.isLoaded ||  !this.$parent.isLazy;

    if(this.isLoaded){
      this.$nextTick(() => {
        this.initObserver();
        this.removeTabIfEmpty();
      });
    }
    // sets active tab on mounted as that's sometimes missed with the watch function on runtime updates.
    if (this.activeTabName === this.tabName) {
      this.isActive = true;
      this.isLoaded = true;
    }
  },
  methods:{
    createTabWithPayload(){
      this.createTab({
        label: this.label || this.tabName,
        tabName: this.tabName,
        navNode: this.$slots.label?.()?.[0],
      });
    },
    removeTabIfEmpty(){
      // check if there is some childNode that is not an empty text node
        const hasContent = this.$refs.content.childNodes?.length > 0 && Array.from(this.$refs.content.childNodes).some(
          (node) => !(node.nodeType === Node.COMMENT_NODE || (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() === ''))
        );
        if (!hasContent && !this.isRemoved) {
          this.removeTab(this.tabName);
          this.isRemoved = true;
        }
        if(hasContent && this.isRemoved){
          this.restoreTab(this.tabName);
          this.isRemoved = false;
        }
    },
    observerCallback(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          this.removeTabIfEmpty();
        }
      }
    },
    initObserver() {
      if (this.observer) return;
      this.observer = new MutationObserver(this.observerCallback);
      this.observer.observe(this.$refs.content, {
        childList: true,
        subtree: true,
      });
    },
  },
};
</script>
<style lang="scss">
@import 'Tabs.scss';
</style>
